import {call, put, select, takeEvery, takeLatest} from 'redux-saga/effects'

import * as nearestShowroomsActions from '../actions/nearestShowrooms'
import * as nearestShowroomSelectors from '../store/nearestShowrooms'
import * as report from '../report'
import {addGlobalHtmlClass, removeGlobalHtmlClass} from '../utils'
import {getNearestShowroomLocations} from '../api/showrooms'
import {onStatus} from '../api/api'
import {receivedNearestShowroomsResponse} from '../track/nearestShowrooms'

/**
 * Get nearest showroom locations within a 50 mile distance of the user's IP address
 */
export function* getNearestShowroomsWorker() {
  yield put(nearestShowroomsActions.getNearestShowroomsPending())
  try {
    const response = yield call(getNearestShowroomLocations, 50)
    const result = onStatus({
      OK: ({json}) => json,
      DEFAULT: () => {
        throw new Error('Unable to fetch nearest showroom locations.')
      },
    })(response)
    yield put(nearestShowroomsActions.getNearestShowroomsSuccess(result))
  } catch (err) {
    report.exception(err)
    yield put(nearestShowroomsActions.getNearestShowroomsFailure(err))
  }
}

export function* getNearestShowroomsSaga() {
  yield takeLatest(nearestShowroomsActions.GET_NEAREST_SHOWROOMS, getNearestShowroomsWorker)
}

export function* getNearestShowroomsSuccessWorker() {
  const tbtLocations = yield select(nearestShowroomSelectors.nearestTheBlackTuxShowrooms)
  const nordstromLocations = yield select(nearestShowroomSelectors.nearestNordstromShowrooms)
  const shouldDisplayShowroomBanner = yield select(
    nearestShowroomSelectors.shouldDisplayNearestShowroomBanner,
  )

  yield call(receivedNearestShowroomsResponse, {
    theBlackTuxLocationCount: tbtLocations.length,
    nordstromLocationCount: nordstromLocations.length,
  })

  return shouldDisplayShowroomBanner
    ? yield put(nearestShowroomsActions.showNearestShowroomBanner())
    : yield put(nearestShowroomsActions.hideNearestShowroomBanner())
}

export function* getNearestShowroomsSuccessSaga() {
  yield takeLatest(
    nearestShowroomsActions.GET_NEAREST_SHOWROOMS_SUCCESS,
    getNearestShowroomsSuccessWorker,
  )
}

const IS_NEAREST_SR_BANNER_OPEN = 'is--nearest-sr-banner-open'

export function* showNearestShowroomsBannerWorker() {
  yield call(addGlobalHtmlClass, IS_NEAREST_SR_BANNER_OPEN)
}

export function* showNearestShowroomsBannerSaga() {
  yield takeEvery(
    nearestShowroomsActions.SHOW_NEAREST_SHOWROOM_BANNER,
    showNearestShowroomsBannerWorker,
  )
}

export function* hideNearestShowroomsBannerWorker() {
  yield call(removeGlobalHtmlClass, IS_NEAREST_SR_BANNER_OPEN)
}

export function* hideNearestShowroomsBannerSaga() {
  yield takeEvery(
    nearestShowroomsActions.HIDE_NEAREST_SHOWROOM_BANNER,
    hideNearestShowroomsBannerWorker,
  )
}
